import React from "react";

const OrderSkeletonLoader = () => {
  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="w-full h-10 bg-gray-200 rounded-md animate-pulse"></div>

      {/* Tabs */}
      <div className="flex space-x-4">
        {[...Array(5)].map((_, i) => (
          <div
            key={i}
            className="w-24 h-8 bg-gray-200 rounded-md animate-pulse"
          ></div>
        ))}
      </div>

      {/* Order Card Skeleton */}
      <div className="border rounded-md p-4 space-y-4 shadow-sm">
        {/* Order header */}
        <div className="flex items-center justify-between">
          <div className="space-y-2">
            <div className="w-32 h-4 bg-gray-200 rounded animate-pulse"></div>
            <div className="w-24 h-4 bg-gray-200 rounded animate-pulse"></div>
          </div>
          <div className="w-20 h-6 bg-yellow-200 rounded animate-pulse"></div>
        </div>

        {/* Product Info */}
        <div className="flex items-center space-x-4">
          <div className="w-24 h-24 bg-gray-200 rounded-md animate-pulse"></div>
          <div className="flex-1 space-y-2">
            <div className="w-48 h-4 bg-gray-200 rounded animate-pulse"></div>
            <div className="w-24 h-4 bg-gray-200 rounded animate-pulse"></div>
            <div className="w-16 h-4 bg-gray-200 rounded animate-pulse"></div>
          </div>
          <div className="w-16 h-4 bg-gray-200 rounded animate-pulse"></div>
        </div>

        {/* Total */}
        <div className="flex justify-end">
          <div className="w-24 h-6 bg-orange-200 rounded animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export default OrderSkeletonLoader;
